import React from 'react';

import './PaypalInfo.css';

export default function PayPalInfo({ email = '' }) {
  if (!email) return null;

  return (
    <div className="paypalInfo" data-dd-privacy="mask">
      <img className="paypalThumb" src="/account/static/images/cards/paypal-logo-01.svg" alt="PayPal" />
      <span className="paypalEmail">{email}</span>
    </div>
  );
}
